export const HEADING_COLUMNS_WHITELIST = {
  small: ['min', 'pointsScored', 'reb', 'ast'],
  medium: ['min', 'pointsScored', 'reb', 'ast', 'bs', 'stl'],
  large: ['min', 'pointsScored', 'fieldGoals', 'fgTwo', 'fgThree', 'ft', 'reb', 'ast', 'bs', 'stl', 'to', 'pf']
}
export const HEADING_FALLBACK_CELLS = {
  small: ['Team name', 'M', 'P', 'R', 'A'],
  medium: ['Team name', 'M', 'P', 'R', 'A', 'BS', 'ST'],
  large: ['Team name', 'M', 'P', 'FG', 'F2', 'F3', 'FT', 'R', 'A', 'BS', 'ST', 'TO', 'PF']
}
export const TABLE_FALLBACK_DATA = [
  { id: '1' },
  { id: '2' },
  { id: '3' },
  { id: '4' },
  { id: '5' },
  { id: '6' },
  { id: '7' },
  { id: '8' },
  { id: '9' },
  { id: '10' },
  { id: '11' },
  { id: '12' },
  { id: '13' }
]
